module.exports = __webpack_public_path__ + "media/images/countrysquared/al-370953e28b8a1d106dd1877edcde9042.svg";